module.exports = __webpack_public_path__ + "static/media/step_012.8471bb48.jpeg";